// DeletePerson.js — the "Delete person" control at the bottom of a contact's
// detail. Three phases, in-page (never window.confirm):
//   idle     the danger button
//   confirm  "Delete <name> from the app and the phone? Photos stay in the
//            library." with Delete / Cancel
//   busy     spinner while onDelete runs
// onDelete(person) is the page's job (relay call + list removal). When it
// resolves the row is gone and this unmounts; when it throws the message is
// shown inline, the confirm stays open, and the person stays in place.
import React, { useState } from 'react';

export const confirmText = name => `Delete ${name} from the app and the phone? Photos stay in the library.`;

/** Pure. The list without that PersonId; order kept; unknown id -> same rows. */
export const removePerson = (people, personId) => people.filter(p => p.personId !== personId);

export default function DeletePerson({ person, disabled, onDelete }) {
  const [phase, setPhase] = useState('idle');   // 'idle' | 'confirm' | 'busy'
  const [err, setErr] = useState(null);
  const busy = phase === 'busy';

  const go = async () => {
    setPhase('busy'); setErr(null);
    try {
      await onDelete(person);
      // success: the page removed the row; nothing to render
    } catch (e) {
      // Message only — never the payload.
      setErr(e?.message || 'Delete failed');
      setPhase('confirm');
    }
  };

  return (
    <div className="Contacts-delete-person">
      {err && <p className="Contacts-inline-error" role="alert">{err}</p>}
      {phase === 'idle' ? (
        <button type="button" className="Contacts-btn Contacts-btn--danger" disabled={disabled}
          onClick={() => { setPhase('confirm'); setErr(null); }}>Delete person</button>
      ) : (
        <div className="Contacts-confirm" role="alertdialog" aria-live="polite">
          <span className="Contacts-confirm-text">{confirmText(person.title)}</span>
          <span className="Contacts-confirm-actions">
            <button type="button" className="Contacts-btn Contacts-btn--danger" disabled={busy || disabled} onClick={go}>
              {busy ? <><span className="Contacts-spinner" aria-hidden="true" /> Deleting…</> : 'Delete'}
            </button>
            <button type="button" className="Contacts-btn" disabled={busy}
              onClick={() => { setPhase('idle'); setErr(null); }}>Cancel</button>
          </span>
        </div>
      )}
    </div>
  );
}
